import Skeleton from './Skeleton';


const SkeletonCardProductBundling = () => (
    <article className="w-full shadowCard p-3 flex flex-col gap-3" aria-busy="true">
        {/* cover 16:9 */}
        <Skeleton className="aspect-[16/9] w-full rounded-[12px]" />

        {/* judul + kategori */}
        <div className="flex flex-col gap-2">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-3/4" />
            <Skeleton className="h-3 w-1/3" />
        </div>

        <div className="h-px w-full bg-blue-cs-200" />

        {/* harga coret + harga */}
        <Skeleton className="h-3 w-1/4" />
        <Skeleton className="h-5 w-1/2" />

        {/* tombol keranjang + beli */}
        <div className="flex items-center gap-3 w-full">
            <Skeleton className="h-[51px] w-[51px] shrink-0" />
            <Skeleton className="h-[51px] flex-1" />
        </div>
    </article>
);

export default SkeletonCardProductBundling;
